<template>
  <div>
    <van-nav-bar
        left-arrow
        title="爱心记录"
        @click-left="$router.push({name: 'userCenter'});"
        left-text="">
    </van-nav-bar>
    <div style="padding-top: 50px" class="wxMyOrderss">
      <div>
        <van-tabs v-model="active" @click="onClickTab">
          <van-tab title="全部"></van-tab>
          <van-tab title="收入"></van-tab>
          <van-tab title="支出"></van-tab>
        </van-tabs>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div
              v-for="item in list"
              :key="item.id">
            <div
                class="van-doc-demo-block__title_k">
              <van-row>
              </van-row>
            </div>
            <van-card>
              <template #title>
                <div style="font-size: 11pt;line-height: 28px">
                  <div style="">时间：{{ item.createTime }}</div>
                  <div style="color:red">状态：{{ types(item.outFlag) }}</div>
                  <div style="float:right;"> {{ '爱心：' + item.amount }}</div>
                </div>
              </template>
            </van-card>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NavBar, Divider,
  Button, Field, Tab, Tabs,
  List, Card
} from 'vant'
import {postAction} from '@/api/manage'

export default {
  components: {
    [Button.name]: Button, [Divider.name]: Divider,
    [List.name]: List, [Tab.name]: Tab, [Tabs.name]: Tabs,
    [Field.name]: Field, [NavBar.name]: NavBar, [Card.name]: Card,
  },

  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      balanceLast: 0,
      urls: 'balanceList',
      kyz: this,
      outFlag: -1,
    }
  },
  mounted() {
  },
  methods: {
    onLoad() {
      this.loadData()
    },
    onClickTab(name) {
      if (name === 0) {
        this.refreshData(-1)
      } else if (name === 1) {
        this.refreshData(0)
      } else {
        this.refreshData(1)
      }
    },
    refreshData(orderFlag) {
      this.loading = false
      this.finished = false
      this.pageNumber = 1
      this.list = []
      this.outFlag = orderFlag
    },
    types(tt) {
      if (tt == 0) {
        return '收入'
      } else if (tt == 1) {
        return '支出'
      }
    },
    loadData() {
      const that = this
      //发送 post 请求
      this.$nextTick(() => {
        postAction('/web/api/user/myLoveRecord', {
          pageNo: that.pageNumber,
          outFlag: this.outFlag
        }).then(function (response) {
          console.log(response.result)
          // 异步更新数据
          for (let i = 0; i < 10; i++) {
            if (response.result.data.records[i]) {
              that.list.push(response.result.data.records[i])
            }
          }
          that.pageNumber = that.pageNumber + 1
          // 加载状态结束
          that.loading = false
          // 数据全部加载完成
          if (that.list.length >= response.result.data.total) {
            that.finished = true
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-card__bottom {
  padding-bottom: 20px;
}

.van-card__desc {
  margin-top: 6px;
}

.van-card__title {
  font-size: 11pt;
}

.wxMyOrderss .van-card__price {
  font-size: 13pt !important;
}

.wxMyOrderss .van-card__price-integer {
  font-size: 13pt !important;
}

.van-nav-bar {
  position: fixed;
  width: 100%;
}

.wxMyOrderss .van-card__bottom {
  padding-bottom: 10px !important;
}

.van-doc-demo-block__title_k {
  margin: 0;
  padding: 7px 14px 0px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 12px;
  background-color: white;
  margin-bottom: -10px;
  margin-top: 10px;
}

</style>
